import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useTokenUsageTracking = () => {
  const queryClient = useQueryClient();

  const trackTokenUsage = useCallback(
    (tokenUsed: string, usageCount: number = 1) => {
      // Invalidate token-related queries after usage
      queryClient.invalidateQueries({ queryKey: ["api-token"] });
      queryClient.invalidateQueries({ queryKey: ["token-overview"] });

      // Optional: Update cache optimistically for immediate feedback
      queryClient.setQueryData(["api-token"], (old: any) => {
        if (!old?.tokens) return old;

        return {
          ...old,
          tokens: old.tokens.map((token: any) => {
            if (token.token === tokenUsed) {
              return {
                ...token,
                usage_count: (token.usage_count || 0) + usageCount,
                quota_remaining: Math.max(
                  0,
                  (token.quota_remaining || 0) - usageCount,
                ),
              };
            }
            return token;
          }),
        };
      });

      // Also update token overview cache for allocations
      queryClient.setQueryData(["token-overview"], (old: any) => {
        if (!old?.tokens) return old;

        return {
          ...old,
          tokens: old.tokens.map((token: any) => {
            if (token.token_name === tokenUsed) {
              return {
                ...token,
                quota_remaining: Math.max(
                  0,
                  (token.quota_remaining || 0) - usageCount,
                ),
              };
            }
            return token;
          }),
        };
      });
    },
    [queryClient],
  );

  return { trackTokenUsage };
};
